import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import ProductTile from './ProductTile'
import ProductQuickViewModal from './ProductQuickViewModal'
import useStateRef from "react-usestateref";
import SortingPaginantion from "./SortingPaginantion";
import Helper from "../Helper";
import { useDispatch, useSelector } from "react-redux";
import { APPLICATION_JSON } from "../../middleware/types";
import { monetateDetailsAction } from "../../middleware/monetateDetailsAction";

const PlpMainContent = ({ containerObject }) => {
	const [containerObjectState, setContainerObjectState] = useState(containerObject && containerObject.results ? containerObject.results : "")
	const [productList, setProductList, productListRef] = useStateRef(containerObject && containerObject.results ? containerObject.results : [])
	const [productIds, setProductIds, productIdsRef] = useStateRef(containerObject?.productIds ? containerObject.productIds : []);
	const [searchedvalue, setSearchedvalue, searchedvalueRef] = useStateRef(containerObject.searchedValue ? containerObject.searchedValue : "")
	const [searchedSpellCheckValue, setSearchedSpellCheckValue, searchedSpellCheckValueRef] = useStateRef(containerObject.searchedSpellCheckValue ? containerObject.searchedSpellCheckValue : "")
	const [productDetailsObj, setproductDetailsObj] = useState('')
	const [cartProductDetails, setCartProductDetails] = useState('')
	const [productCount, setProductCount, productCountRef] = useStateRef('')
	const [currentView, setCurrentView] = useState(containerObject && containerObject.listingPageViewType ? containerObject.listingPageViewType : "gridView")
	const [search, setSearch, searchRef] = useStateRef("");
	const [facetFields, setFacetFields, facetFieldsRef] = useStateRef(false);
	const [isAddToCartAction, setIsAddToCartAction, isAddToCartActionRef] = useStateRef(true);
	const [productSearchPageUrlState, setProductSearchPageUrlState] = useState(containerObject && containerObject.productSearchPageUrl ? containerObject.productSearchPageUrl : "browse/product-search-results");
	const [contentSearchPageUrlState, setContentSearchPageUrlState] = useState(containerObject && containerObject.contentSearchPageurl ? containerObject.contentSearchPageurl : "browse/content-search-results");
	const cartDetails = useSelector(state => state.getCartDetails.cartDetails);
	const history = useHistory();
	const dispatch = useDispatch();
	const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
	const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
	const resourceCategoryPageTypes = ['Resources_Care', 'Resources_SDS' ];

	// Store the last tracked URL to prevent duplicates
	// const lastTrackedUrl = useRef('');

	useEffect(() => {
		setSearch(window.location.search)
	}, [])


	useEffect(()=>{
        let productIds = [];
        productListRef.current && productListRef.current.map((value, index)=>{
            productIds.push(value["product.productId"])
        })
        console.log('productIds...',productIds);
        window.monetateQ = window.monetateQ || [];
        if(containerObject.searchedValue){
            dispatch(monetateDetailsAction({addProducts : ["addProducts", productIds], addSearch : [ "addSearch", {"searchTerm": containerObject.searchedValue, "searchType": "site"}], setPageType : ["setPageType", "search"] }))     
        
        }else{
			dispatch(monetateDetailsAction({addProducts : ["addProducts", productIds]})) 
			// console.log('containerObject?.pageType...',containerObject?.pageType);
			// if(/\.co(?!m)/.test(window.location.href)){
			// 	if(!resourceCategoryPageTypes.includes(containerObject?.pageType)){
			// 	console.log('one');

			// 	}else{
			// 		console.log('two');
			// 		dispatch(monetateDetailsAction({addProducts : ["addProducts", productIds]}))        
			// 	}
            // }
            // else{
				
			// 	console.log('three',window.location.href);
			// 	dispatch(monetateDetailsAction({addProducts : ["addProducts", productIds]}))        
            // }
        }
        let monetateData = {'addProducts' : productIds}
        console.log('monetateData in plp...',monetateData);
    },[])

	useEffect(()=>{
		console.log('containerObject.disableAjaxCallForCDN in plp..',containerObject);
		if(containerObject.disableAjaxCallForCDN == 'N'){
			getPriceListFromATG();
		}
	},[searchRef.current])

	async function getPriceListFromATG (){
		console.log("getPriceListFromATG......called...",containerObject);
		const inputMap = {
			productIdList : containerObject.productIds,
			searchTerm : containerObject.searchedValue ? containerObject.searchedValue :""
		}
		var actionUrl = `api/rest/cb/product/price-list-from-atg`;
	var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
		var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))
		console.log('response...error...',res?.productPrices);
		if (res?.responseMessage == "success") {
			console.log("success......????? before...",productListRef.current);
			let tempResults = productListRef.current;
			tempResults?.map((oneProduct, key)=>{
				if(productIdsRef.current?.includes(oneProduct['product.productId'])){
					const productObj = res?.productPrices[oneProduct['product.productId']];
					Object.entries(productObj).map(([key, value], i) => {
						oneProduct[key] = value;
					  }) 
				}
				
			})
			setProductList(tempResults);
			console.log("success......????? after...",productListRef.current);


		}
		else {
			console.log('response...error...',res);
		}
	}

	const productDetailsCallBack = (productDetails) => {
		setproductDetailsObj(productDetails)
		console.log('productDetailsObj...',productDetails);
	}

	const cartProductDetailsCallBack = (productDetails) => {
		setCartProductDetails(productDetails)
	}

	const handleAddToCartAction = (addToCart) => {
		setIsAddToCartAction(addToCart)
	}

	const productCountCallBack = (count) => {
		setProductCount(count)
	}

	const handleViewType = async (event) => {
		var viewType = event.currentTarget.id
		var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/static/set-listing-page-view-type/${viewType}`
		var response = await Helper.fetchCallFunction(Url, "GET", false, null, null)
		if (response.result == "success") {
			setCurrentView(response.currentView ? response.currentView : "")
			if(containerObject.isSearchPage === true) {
				const viewListData = {
					"event": "search",
					"page_type": "search results",
					"searchCountProducts": String(containerObject.Product),
					"searchCountResources": String(containerObject.Content),
					"searchQuery": searchedvalueRef.current,
					"sortOrder": "",
					"tab": response.currentView ? response.currentView == "listView" ? "List" : "Grid" : "Grid"
				}
				window.dataLayer = window.dataLayer || []
				if (window.dataLayer.length > 0) {
					window.dataLayer.push(viewListData)
				}
			}
		}
	}


	const constructUrl = (tab, type) => {

		var parameters = "";
		if (type == "Content") {
			parameters = `/${contentSearchPageUrlState}?q=${encodeURIComponent(containerObject.searchedValue)}&product.type=${type}&tab=${tab}`
		} else {
			parameters = `/${productSearchPageUrlState}?q=${encodeURIComponent(containerObject.searchedValue)}&product.type=${type}&tab=${tab}`
		}
		history.push(parameters)
	}

	useEffect(() => {
		let params = new URLSearchParams(searchRef.current)
		params = params.toString()
		if (containerObject && containerObject.listSize == 0 && containerObject.Content && parseInt(containerObject.Content) > 0) {
			window.location.replace(`/${contentSearchPageUrlState}?q=${encodeURIComponent(containerObject.searchedValue)}&product.type=Content&tab=c`)
		} else {
			if (loaderStatus != true && (((containerObject.Content && parseInt(containerObject.Content) == 0) || containerObject.Content == undefined) || ((containerObject.Product && parseInt(containerObject.Product) == 0) || containerObject.Product == undefined)) && containerObject && productListRef.current && containerObject.listSize == 1 && containerObject.isSearchPage === true && !params.includes("facetFields")) {
				setFacetFields(true)
				productListRef.current.map(oneElem => {
					window.location.replace(oneElem.productUrl)
				})
			}
		}
	}, [productListRef.current])


	useEffect(() => {
		const titleElement = document.querySelector('title')
		if (containerObject.currentCategoryName) {
			titleElement.innerHTML = containerObject.currentCategoryName + " | Carolina Biological Supply"
		} else if (containerObject.isSearchPage === true && containerObject.isSearchPage) {
			titleElement.innerHTML = "Carolina Biological Supply Search for: " + containerObject.searchedValue
		} else {
			titleElement.innerHTML = "Carolina Biological Supply"
		}
	}, [containerObject])


	return (

		<div classNameName="col-md-12 container-fluid justify-content-around row p-2 my-2 ">
			{productListRef.current && productListRef.current.length == 1 && containerObject?.isSearchPage === true && facetFieldsRef.current === true ? "" :
				<>
					{containerObject && productListRef.current && productListRef.current.length > 0 && !containerObject.hidePlpPage ? <>

						{searchedvalueRef.current ?
							<div className="c-results-tabs">
								<ul id='myTabProduct' className='nav nav-tabs' role='tablist'>
									{containerObject && containerObject.Product ? <li className={`nav-item`} role='presentation'>
										<p class={`nav-link text-center ${containerObject.productViewType === "p" ? "active" : ""}`} onClick={() => constructUrl("p", "Product")} type="button" aria-selected="true">Products <span class="c-tab-count">({containerObject.Product ? containerObject.Product : ""})</span></p>
									</li> : ""}
									{profileDetails && profileDetails.userTypeCheck && profileDetails.userTypeCheck.punchoutClient ? "" : containerObject && containerObject.Content ? <li className={`nav-item`} role='presentation'>
										<p class={`nav-link text-center ${containerObject.productViewType === "c" ? "active" : ""}`} onClick={() => constructUrl("c", "Content")} type="button" aria-selected="false" tabindex="-1">Resources <span class="c-tab-count">({containerObject.Content ? containerObject.Content : ""})</span></p>
									</li> : ""}
								</ul>
							</div> : ""}

						<div class="category-view d-none d-lg-block d-lg-flex mx-3">
							<p class="category-view-title">View</p>
							<ul class="nav justify-content-end nav-pills">
								<li class="nav-item">
									<Link class={`nav-link view-btn ${currentView == "gridView" ? "active" : ""}`} style={{ "font-size": "12px" }} id="gridView" onClick={handleViewType}>
										<i class="fa fa-th-large p-1" style={{ "font-size": "12px" }}>
										</i>Grid</Link>
								</li>
								<li class="nav-item">
									<Link class={`nav-link view-btn ${currentView == "listView" ? "active" : ""}`} style={{ "font-size": "12px" }} id="listView" onClick={handleViewType}>
										<i class="fa fa-th-list p-1" style={{ "font-size": "12px" }}>
										</i>List</Link>
								</li>
							</ul>
						</div>
						{/* Facet Mobile view button */}
						<div className={`d-lg-none d-block facet-mobile-view ${containerObject && containerObject.isChildCategoryAvailable ? "d-none" : ""}`}>
							<button class="btn btn-primary facet-refine-btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Refine</button>
						</div>

						<SortingPaginantion containerObject={containerObject} isPagination={false} isSorting={true} />
						<div class="row cb-results-page mt-3">
							{productListRef.current ? productListRef.current.map((value, index) => {
								return (<>
									<ProductTile domainName={containerObject.domainName ? containerObject.domainName : ""} pageType={containerObject.productViewType && containerObject.productViewType === "p" ? "product" : containerObject.productViewType && containerObject.productViewType === "c" ? "resources" : ""} value={value ? value : ""} indexValue={index} currentPageView={currentView} productDetailsCallBack={productDetailsCallBack} productCountCallBack={productCountCallBack} gridViewCol={containerObject && containerObject.attributes && containerObject.attributes.colPerRowSizeForGridView ? containerObject.attributes.colPerRowSizeForGridView : ""} documentFetchPriorityHighCount={containerObject.documentFetchPriorityHighCount} />
								</>)
							}) : ""}
						</div>
						<ProductQuickViewModal handleAddToCartAction={handleAddToCartAction} productObj={productDetailsObj ? productDetailsObj : "0"} solrValue={productDetailsObj.activeFlagCount ? productDetailsObj.activeFlagCount:''} cartProductDetailsCallBack={cartProductDetailsCallBack} />
						<SortingPaginantion containerObject={containerObject} isPagination={true} isSorting={false} />

					</> : ""}</>}
		</div>
	)
}

export default PlpMainContent
